__turbopack_context__.v({
  "container": "styles-module__a_4ySG__container",
  "cta": "styles-module__a_4ySG__cta",
  "dismissModalButton": "styles-module__a_4ySG__dismissModalButton",
  "shieldIcon": "styles-module__a_4ySG__shieldIcon",
  "textBody": "styles-module__a_4ySG__textBody",
  "title": "styles-module__a_4ySG__title",
});
